"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

type BookmarkStoreT = {
  vehicleIds: number[];
  contactPersonIds: string[];
  addVehicleBookmark: (id: number) => void;
  removeVehicleBookmark: (id: number) => void;
  toggleVehicleBookmark: (id: number) => void;
  isVehicleBookmarked: (id: number) => boolean;
  addContactPersonBookmark: (id: string) => void;
  removeContactPersonBookmark: (id: string) => void;
  toggleContactPersonBookmark: (id: string) => void;
  isContactPersonBookmarked: (id: string) => boolean;
  clearAllBookmarks: () => void;
};

export const useBookmarkStore = create<BookmarkStoreT>()(
  persist(
    (set, get) => ({
      vehicleIds: [],
      contactPersonIds: [],

      addVehicleBookmark: (id) => {
        const currentIds = get().vehicleIds;
        if (!currentIds.includes(id)) {
          set({ vehicleIds: [...currentIds, id] });
        }
      },

      removeVehicleBookmark: (id) => {
        set({
          vehicleIds: get().vehicleIds.filter((vehicleId) => vehicleId !== id),
        });
      },

      toggleVehicleBookmark: (id) => {
        const isBookmarked = get().isVehicleBookmarked(id);
        if (isBookmarked) {
          get().removeVehicleBookmark(id);
        } else {
          get().addVehicleBookmark(id);
        }
      },

      isVehicleBookmarked: (id) => {
        return get().vehicleIds.includes(id);
      },

      addContactPersonBookmark: (id) => {
        const currentIds = get().contactPersonIds;
        if (!currentIds.includes(id)) {
          set({ contactPersonIds: [...currentIds, id] });
        }
      },

      removeContactPersonBookmark: (id) => {
        set({
          contactPersonIds: get().contactPersonIds.filter(
            (contactPersonId) => contactPersonId !== id
          ),
        });
      },

      toggleContactPersonBookmark: (id) => {
        const isBookmarked = get().isContactPersonBookmarked(id);
        if (isBookmarked) {
          get().removeContactPersonBookmark(id);
        } else {
          get().addContactPersonBookmark(id);
        }
      },

      isContactPersonBookmarked: (id) => {
        return get().contactPersonIds.includes(id);
      },

      clearAllBookmarks: () => {
        set({ vehicleIds: [], contactPersonIds: [] });
      },
    }),
    {
      name: "wiest-group-bookmarks",
    }
  )
);
